import React, { useState } from "react";
import { X } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Dialog, DialogContent, DialogTrigger } from "../components/ui/dialog";
import { supabase } from "../lib/supabase";

const getGalleryImageUrl = (filename) => {
	const { data } = supabase.storage
		.from("images")
		.getPublicUrl(`gallery/${filename}`);
	return data.publicUrl;
};

const getVideoUrl = (filename) => {
	const { data } = supabase.storage
		.from("images")
		.getPublicUrl(`gallery/${filename}`);
	return data.publicUrl;
};

const isVideoFile = (url) => {
	const videoExtensions = [".mp4", ".webm", ".mov", ".m4v"];
	return videoExtensions.some((ext) => url.toLowerCase().includes(ext));
};

const galleryImages = [
	{
		id: 1,
		src: getGalleryImageUrl("IMG_1965.jpeg"),
		alt: "Intérieur du café",
		category: "ambiance",
	},
	{
		id: 2,
		src: getGalleryImageUrl("IMG_1966.jpeg"),
		alt: "Cappuccino parfait",
		category: "ambiance",
	},
	{
		id: 3,
		src: getGalleryImageUrl("IMG_1967.jpeg"),
		alt: "Latte art",
		category: "ambiance",
	},
	{
		id: 4,
		src: getGalleryImageUrl("IMG_1969.jpeg"),
		alt: "Croissants frais",
		category: "viennoiseries",
	},
	{
		id: 5,
		src: getGalleryImageUrl("IMG_1970.jpeg"),
		alt: "Espresso",
		category: "ambiance",
	},
	{
		id: 6,
		src: getGalleryImageUrl("IMG_1971.jpeg"),
		alt: "Espace de travail",
		category: "viennoiseries",
	},
	{
		id: 7,
		src: getGalleryImageUrl("IMG_1972.jpeg"),
		alt: "Cookies maison",
		category: "viennoiseries",
	},
	{
		id: 8,
		src: getGalleryImageUrl("IMG_1973.jpeg"),
		alt: "Grains de café",
		category: "ambiance",
	},
	{
		id: 9,
		src: getGalleryImageUrl("IMG_1975.jpeg"),
		alt: "Brioche dorée",
		category: "ambiance",
	},
	{
		id: 10,
		src: getGalleryImageUrl("IMG_1976.jpeg"),
		alt: "Double espresso",
		category: "ambiance",
	},
	{
		id: 11,
		src: getGalleryImageUrl("IMG_1977.jpeg"),
		alt: "Chocolat chaud",
		category: "ambiance",
	},
	{
		id: 12,
		src: getGalleryImageUrl("IMG_1978.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 13,
		src: getGalleryImageUrl("IMG_1979.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 14,
		src: getGalleryImageUrl("IMG_1980.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 15,
		src: getGalleryImageUrl("IMG_1981.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 16,
		src: getGalleryImageUrl("IMG_1982.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 17,
		src: getGalleryImageUrl("IMG_1983.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 18,
		src: getGalleryImageUrl("IMG_1984.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 19,
		src: getGalleryImageUrl("IMG_1985.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 20,
		src: getGalleryImageUrl("IMG_1986.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 21,
		src: getGalleryImageUrl("IMG_1987.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 22,
		src: getGalleryImageUrl("IMG_1988.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 23,
		src: getGalleryImageUrl("IMG_1989.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 24,
		src: getGalleryImageUrl("IMG_1990.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 25,
		src: getGalleryImageUrl("IMG_1991.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 26,
		src: getGalleryImageUrl("IMG_1992.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 27,
		src: getGalleryImageUrl("IMG_1993.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 28,
		src: getGalleryImageUrl("IMG_1994.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 29,
		src: getGalleryImageUrl("IMG_1995.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 30,
		src: getGalleryImageUrl("IMG_1996.jpg"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
	},
	{
		id: 31,
		src: getVideoUrl("VID_0001.mp4"),
		alt: "Ambiance du coffee shop",
		category: "ambiance",
		type: "video",
	},
];

const categories = [
	{ id: "all", name: "Tout" },
	{ id: "ambiance", name: "Ambiance" },
	{ id: "cafe", name: "Café" },
	{ id: "viennoiseries", name: "Viennoiseries" },
	{ id: "sandwich", name: "Sandwich" },
	{ id: "patisserie", name: "Pâtisserie" },
	{ id: "production", name: "Production" },
];

export default function GalleryPage() {
	const [selectedCategory, setSelectedCategory] = useState("all");

	const filteredImages =
		selectedCategory === "all"
			? galleryImages
			: galleryImages.filter((img) => img.category === selectedCategory);

	const pageTitle = "Galerie | Léger's Coffee Genève";
	const pageDescription =
		"Découvrez la galerie photo de Léger's Coffee à Genève : ambiance du coffee shop, cafés de spécialité, pâtisseries artisanales et moments gourmands.";
	const canonicalUrl = "https://legerscoffee.fr/galerie";
	const ogImage =
		galleryImages[0]?.src || "https://legerscoffee.fr/og-image.jpg";

	const structuredDataCollectionPage = {
		"@context": "https://schema.org",
		"@type": "CollectionPage",
		name: "Galerie | Léger's Coffee",
		url: canonicalUrl,
		description: pageDescription,
		inLanguage: "fr-CH",
	};

	const structuredDataImageGallery = {
		"@context": "https://schema.org",
		"@type": "ImageGallery",
		name: "Galerie photos Léger's Coffee",
		url: canonicalUrl,
		description: pageDescription,
		associatedMedia: galleryImages.map((image) => ({
			"@type": "ImageObject",
			contentUrl: image.src,
			description: image.alt,
		})),
	};

	return (
		<>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
				<meta name="robots" content="index, follow" />
				<link rel="canonical" href={canonicalUrl} />

				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Léger's Coffee" />
				<meta property="og:locale" content="fr_CH" />
				<meta property="og:title" content={pageTitle} />
				<meta property="og:description" content={pageDescription} />
				<meta property="og:url" content={canonicalUrl} />
				<meta property="og:image" content={ogImage} />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={pageTitle} />
				<meta name="twitter:description" content={pageDescription} />
				<meta name="twitter:image" content={ogImage} />

				<script type="application/ld+json">
					{JSON.stringify(structuredDataCollectionPage)}
				</script>
				<script type="application/ld+json">
					{JSON.stringify(structuredDataImageGallery)}
				</script>
			</Helmet>

			<main data-testid="gallery-page" className="min-h-screen pt-20">
				{/* Hero */}
				<section className="bg-warm-secondary py-16 lg:py-24">
					<div className="max-w-7xl mx-auto px-6 lg:px-12">
						<div className="text-center max-w-2xl mx-auto">
							<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
								Notre Univers
							</span>
							<h1 className="font-serif text-4xl lg:text-5xl text-espresso font-semibold mb-6">
								Galerie
							</h1>
							<p className="text-soft-charcoal-secondary">
								Découvrez l'atmosphère chaleureuse de Léger's Coffee à travers
								notre galerie photos.
							</p>
						</div>
					</div>
				</section>

				{/* Filters */}
				<section className="sticky top-20 z-40 bg-warm-alabaster border-b border-border-subtle py-4">
					<div className="max-w-7xl mx-auto px-6 lg:px-12">
						<div className="flex flex-wrap gap-2 justify-center">
							{categories.map((cat) => (
								<button
									key={cat.id}
									onClick={() => setSelectedCategory(cat.id)}
									data-testid={`filter-${cat.id}`}
									className={`px-6 py-2 text-sm font-medium uppercase tracking-wider transition-all duration-300 ${
										selectedCategory === cat.id
											? "bg-espresso text-warm-alabaster"
											: "bg-transparent text-soft-charcoal hover:bg-warm-secondary"
									}`}
								>
									{cat.name}
								</button>
							))}
						</div>
					</div>
				</section>

				{/* Gallery Grid */}
				<section className="py-16 lg:py-24 bg-warm-alabaster">
					<div className="max-w-7xl mx-auto px-6 lg:px-12">
						{filteredImages.length === 0 ? (
							<p className="text-center text-soft-charcoal-secondary py-12">
								Aucune image dans cette catégorie.
							</p>
						) : (
							<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
								{filteredImages.map((image, index) => (
									<Dialog key={image.id}>
										<DialogTrigger asChild>
											<button
												type="button"
												className="group relative aspect-square overflow-hidden bg-warm-secondary cursor-pointer opacity-0 animate-fade-in"
												style={{
													animationDelay: `${(index % 6) * 0.1}s`,
												}}
												data-testid={`gallery-image-${image.id}`}
											>
												{isVideoFile(image.src) ? (
													<video
														src={image.src}
														muted
														loop
														playsInline
														autoPlay
														className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
													/>
												) : (
													<img
														src={image.src}
														alt={image.alt}
														loading="lazy"
														className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
													/>
												)}
												<div className="absolute inset-0 bg-espresso/0 group-hover:bg-espresso/20 transition-colors duration-300" />
												<div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-espresso/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
													<p className="text-warm-alabaster text-sm font-medium">
														{image.alt}
													</p>
												</div>
											</button>
										</DialogTrigger>
										<DialogContent className="max-w-4xl p-0 bg-transparent border-none">
											{isVideoFile(image.src) ? (
												<video
													src={image.src}
													controls
													autoPlay
													className="w-full h-auto max-h-[80vh]"
												/>
											) : (
												<img
													src={image.src}
													alt={image.alt}
													className="w-full h-auto max-h-[80vh] object-contain"
												/>
											)}
										</DialogContent>
										<DialogContent className="max-w-4xl p-0 bg-transparent border-none">
											{isVideoFile(image.src) ? (
												<video
													src={image.src}
													controls
													autoPlay
													className="w-full h-auto max-h-[80vh]"
												/>
											) : (
												<img
													src={image.src}
													alt={image.alt}
													className="w-full h-auto max-h-[80vh] object-contain"
												/>
											)}
										</DialogContent>
									</Dialog>
								))}
							</div>
						)}
					</div>
				</section>
			</main>
		</>
	);
}
